module.exports = __webpack_public_path__ + "static/media/sprite_blob-blue.18a983c6.svg";